import { useEffect, useRef } from 'react'
import attribution from 'lib/tracking/attribution/attribution'
import { loadScript } from 'lib/utils'
import { trackEvent } from 'lib/tracking/analytics-service'
import { AnalyticsEventCalendlyBooked } from 'lib/constants/AnalyticsEventType'
import { getReferrerScreen } from 'lib/formatting/url'
import { useRouter } from 'next/router'
import styled from 'styled-components'

declare const Calendly: any

const Container = styled.div`
    height: 100vh;
`

const CalendlyElement = () => {
    const router = useRouter()
    const element = useRef<HTMLDivElement>(null)

    const onBooked = () => {
        trackEvent(AnalyticsEventCalendlyBooked, {})
    }

    const loadCalendly = (source: string | undefined, sourceCampaign: string | undefined) => {
        loadScript('https://assets.calendly.com/assets/external/widget.js', () => {
            Calendly.initInlineWidget({
                url: 'https://calendly.com/knowunity-b2b/ads',
                parentElement: element.current,
                utm: {
                    utmSource: source,
                    utmCampaign: sourceCampaign,
                    utmMedium: 'knowunity-website',
                    utmTerm: getReferrerScreen(router),
                },
            })
        })
    }

    const eventHandler = (event: MessageEvent) => {
        const isCalendlyEvent =
            event.origin === 'https://calendly.com' && event.data.event && event.data.event.indexOf('calendly.') === 0
        if (!isCalendlyEvent) {
            return
        }

        const eventName = event.data.event
        if (eventName === 'calendly.event_scheduled') {
            onBooked()
        }
    }

    useEffect(() => {
        const attributionData = attribution.getAttribution()
        loadCalendly(attributionData.source, attributionData.sourceCampaign)
        window.addEventListener('message', eventHandler)
        return () => {
            window.removeEventListener('message', eventHandler)
        }
    }, [])

    return <Container ref={element} />
}

export default CalendlyElement
